import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import Select from "react-select";
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Flatpickr from "react-flatpickr";
import { dateFormat, dateTimeFormat, dateTimeFormatIOS, formatDateToISO } from 'pages/Common';
import Dropzone from "react-dropzone"
import Compressor from "compressorjs"
import uploadImage from "../../assets/images/uploadImage.png"


const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            border: "1px solid #ced4da",
            minHeight: "38px",
            padding: "3px 10px",
            fontSize: "12px",
            backgroundColor: isDisabled ? "#e9ecef" : "#fff",
            color: isDisabled ? "Black" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            pointerEvents: isDisabled ? "none" : "auto",  // Important for full disabling
            opacity: isDisabled ? 0.6 : 1,
        };
    },
}

const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const CreateUpdateCuttingRequirementModel = ({ modal, toggle, isEdit, editData, CuttingRequirementListApi }) => {
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [previewUrl, setPreviewUrl] = useState('')
    const [categoryError, setCategoryError] = useState(false)
    const [selectedCategoriesIds, setSelectedCategoriesIds] = useState()
    const [categoryErrorMessage, setCategoryErrorMessage] = useState(false)
    const [categoriesData, setCategoriesData] = useState([])
    const [requiredDate, setRequiredDate] = useState(editData ? dateFormat(
        editData?.RequiredDate?.split("T")[0],
        "dd-MM-yyyy"
    ) : dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))
    useEffect(() => {
        setPreviewUrl('')
        setSelectedCategoriesIds()
        setRequiredDate(new Date())
    }, [])


    useEffect(() => {
        setSelectedCategoriesIds()
        if (editData && isEdit) {
            setPreviewUrl(editData?.Image)
        } else {
            setPreviewUrl('')
            setSelectedCategoriesIds()
        }

        getApi('Common/category/lookup').then(({ data, status }) => {
            if (status === 200) {
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                    Value2: item.Value2
                }));

                if (isEdit && editData?.CategoryIds) {
                    const selectedIds = editData.CategoryIds.split(",");
                    const selectedCategories = options.filter(opt =>
                        selectedIds.includes(opt.value.toString())
                    );
                    setSelectedCategoriesIds(selectedCategories);
                }

                setCategoriesData(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [editData])

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    // Requirement Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            Qty: editData ? editData?.Qty : '',
            profilePic: "",
        },
        validationSchema: Yup.object({
            Qty: Yup.string().required("The Qty is required"),
        }),
        onSubmit: values => {

            if (selectedCategoriesIds.length == 0) {
                setCategoryError(true)
                setCategoryErrorMessage('The categories is required')
                return true
            }

            setformSumitLoading(true)
            if (values) {
                const profilePic =
                    (values.profilePic == "" || values.profilePic == undefined)
                        ? previewUrl
                        : values.profilePic.split(",")[1]

                if (isEdit) {
                    putApi("CuttingRequirement/update", {
                        Id: editData.Id,
                        CategoryIds: selectedCategoriesIds?.map(item => item.value).join(','),
                        Qty: parseInt(values.Qty),
                        Image: profilePic || '',
                        RequiredDate: formatDateToISO(requiredDate)
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully updated", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            if (CuttingRequirementListApi != '') {
                                CuttingRequirementListApi()
                            }
                            validation.handleReset()
                        }
                    })
                } else {
                    postApi("CuttingRequirement/create", {
                        CategoryIds: selectedCategoriesIds?.map(item => item.value).join(','),
                        Qty: parseInt(values.Qty),
                        Image: profilePic,
                        RequiredDate: formatDateToISO(requiredDate)
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 200) {
                            toast.success("Successfully Created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            if (CuttingRequirementListApi != '') {
                                CuttingRequirementListApi()
                            }
                            validation.handleReset()
                        } else {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        }
                    })
                }
            }
        },
    })

    const toBase64 = file =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })

    const handleDrop = acceptedFiles => {
        const selectedFile = acceptedFiles[0]
        new Compressor(selectedFile, {
            quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
            success: async compressedResult => {
                setPreviewUrl(URL.createObjectURL(compressedResult))
                validation.setFieldValue("profilePic", await toBase64(compressedResult))
            },
        })
    }

    const handleMultiCategoriesSelected = (category) => {
        setSelectedCategoriesIds(category)
        setCategoryError(false)
        setCategoryErrorMessage('')
    }


    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="xl"
            style={{ width: !isMobile ? "600px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Cutting Requirement" : "Create Cutting Requirement"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >

                        <Row>
                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <div>
                                        <Label htmlFor="FollowupValidation1Custom01" className="required">
                                            Required Date
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    // enableTime: true,
                                                    dateFormat: "d-m-Y",
                                                    disableMobile: true
                                                }}
                                                value={requiredDate}
                                                onChange={(e) => { setRequiredDate(e) }}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className=''
                                    >
                                        Qty
                                    </Label>
                                    <Input
                                        name="Qty"
                                        placeholder="0"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Qty}
                                        onKeyPress={handleKeyPress}
                                        invalid={
                                            validation.touched.Qty && validation.errors.Qty
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Qty && validation.errors.Qty ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Qty}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>

                            <Row>
                                <Col md={12}>
                                    <Label htmlFor="validationCustom03" className="required">
                                        Categories
                                    </Label>
                                    <Select
                                        key={selectedCategoriesIds}
                                        unstyled
                                        isMulti
                                        styles={categoryError ? colourStyles1 : colourStyles}
                                        value={selectedCategoriesIds}
                                        onChange={(e) => handleMultiCategoriesSelected(e)}
                                        options={categoriesData}
                                        className="select2-selection"
                                    />
                                    {categoryError ? (
                                        <div className="name-required">
                                            {categoryErrorMessage}
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>
                        </Row>

                        <Row>
                            <FormGroup>
                                <Dropzone
                                    onDrop={handleDrop}
                                    onClick={handleDrop}
                                    accept="image/*"
                                    multiple={false}
                                    id="profilePic"
                                    name="profilePic"
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <>
                                            <div className="d-flex flex-column align-items-center text-center p-2 py-3">
                                                {previewUrl ? (
                                                    <>
                                                        <div className="position-relative overflow-hidden product-image">
                                                            <input {...getInputProps()} />
                                                            <img
                                                                style={{
                                                                    cursor: "pointer",
                                                                    border: "1px solid #ced4da",
                                                                    borderRadius: "3px",
                                                                }}
                                                                width="175px"
                                                                height="200px"
                                                                src={previewUrl}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <input {...getInputProps()} />

                                                        <div
                                                            style={{
                                                                width: "175px",
                                                                height: "200px",
                                                                border: "1px solid #ced4da",
                                                                cursor: "pointer",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "3px",
                                                            }}
                                                        >
                                                            <img
                                                                className="img-fluid"
                                                                style={{}}
                                                                src={uploadImage}
                                                                {...getRootProps()}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {validation.touched.profilePic && validation.errors.profilePic ? (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.profilePic}
                                                    </FormFeedback>
                                                ) : null}
                                            </div>
                                        </>
                                    )}
                                </Dropzone>
                            </FormGroup>
                        </Row>

                        <div className="text-end">
                            <Button
                                task-title="secondary"
                                className="btn btn-primary me-2 btn-sm "
                                // type="reset"
                                onClick={() => toggle()}
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    color="primary"
                                    task-title="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal >
    )
}

export default CreateUpdateCuttingRequirementModel